import * as React from 'react';
import { useItem } from '../../../hooks/item/ItemProvider';
import { makeStyles, Text, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import CardSelector from '../../../components/CardSelector';
import { OutlookAttachment } from '../../../hooks/client/types/CreateEmailObjectRequest';
import { AttachmentCard } from '../../../components/AttachmentCard';
import { useClient } from '../../../hooks/client';

const useStyles = makeStyles({
  container: {
    paddingInline: tokens.spacingHorizontalXXL,
    paddingBlock: tokens.spacingVerticalXXL,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXL,
  },
  heading: {
    margin: 0,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    display: 'block',
    fontSize: tokens.fontSizeBase400,
    marginBottom: tokens.spacingVerticalXS,
  },
  subheading: {
    color: tokens.colorNeutralForeground3,
  },
  headerGroup: {
    marginBottom: tokens.spacingVerticalXXL,
  },
});

const AttachmentsTab = () => {
  const { attachments, emailObject, setFormValue } = useItem();
  const { t } = useTranslation();
  const { configuration } = useClient();
  const styles = useStyles();

  const handleAttachmentsChanged = (attachmentIds: Set<string>) => {
    const attachmentsMap = new Map();

    for (const attachment of attachments) {
      attachmentsMap.set(attachment.id, attachmentIds.has(attachment.id));
    }

    setFormValue('selectedAttachments', attachmentsMap);
  };

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.headerGroup}>
          <Text
            className={styles.heading}
            as="h2"
          >
            {t('ATTACHMENTS_TAB.ATTACHMENTS')}
          </Text>
          <Text className={styles.subheading}>
            {t('ATTACHMENTS_TAB.ATTACHMENTS_DESCRIPTION', { documentName: configuration.entityDefinitions.attachment.name })}
          </Text>
        </div>
        <CardSelector<OutlookAttachment, string>
          emptyListPlaceholder={t('ATTACHMENTS_TAB.EMPTY')}
          items={attachments}
          keySelector={(attachment) => attachment.id}
          render={(attachment) => <AttachmentCard attachment={attachment} />}
          selectedItems={new Set([...emailObject.selectedAttachments].filter((x) => x[1]).map((x) => x[0]))}
          onSelectionChange={handleAttachmentsChanged}
        />
      </div>
    </div>
  );
};

export default AttachmentsTab;
